<template>
	<div class="page-login">
		<div class="container" v-if="!showErrorInformation">
			<div class="login-logo text-center">
				<img src="/img/logo/grafias_medium_ondark.png" class="d-inline-block m-auto" loading="lazy" alt="Grafias">
			</div>
			<div class="message-box text-center" v-if="!isJoined">
				<div class="message-box-icon flex-center mb-5">
					<div class="white-dot"></div>
				</div>
				<h3 class="mb-4">{{ $t('Joining your account to the rundown') }}</h3>
				<div class="text-lg mb-4">
					Please wait for a few seconds while we prepare the rundown<br>
				</div>
			</div>
			<div class="message-box text-center" v-if="isJoined">
				<div class="message-box-icon flex-center text-center mb-5">
					<!-- <div class="white-dot"></div> -->
					<i class="material-icons d-block m-auto md-36 text-success">check</i>
				</div>
				<h3 class="mb-4">{{ messageSuccess }}</h3>
				<router-link
					to="/"
					class="btn btn-submit btn-primary mt-3">
					{{ $t('Go to Rundowns') }}
				</router-link>
			</div>
		</div>
		<div class="message-box text-center" v-if="showErrorInformation">
			<div class="login-logo text-center mb-0">
				<img src="/img/logo/grafias_medium_ondark.png" class="d-inline-block m-auto" loading="lazy" alt="Grafias">
			</div>
			<img src="/img/OOPS.png" class="d-inline-block m-auto" loading="lazy" alt="Grafias">
			<span>
				<h3 class="mb-5 mt-4 text-center">{{ messageError }},
				<router-link
					to="/"
					class="primary-text pb-1">
					{{ $t('Going back to Dashboard') }}
				</router-link></h3>
			</span>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getAxiosErrorMessage } from '../lib/helper';
import collaboratorsApi from '@/api/collaborators';

export default {
	name: 'CollaboratorsInvitaion',
	data() {
		return {
			isJoining: true,
			isJoined: false,
			showErrorInformation: false,
			messageError: '',
			messageSuccess: '',
		};
	},
	methods: {
		joiningToRundown() {
			this.isJoining = true;
			const params = {
				url: this.invitationUrl,
				name: this.user && this.user.name ? this.user.name : '',
				email: this.user && this.user.email ? this.user.email : '',
			};
			const callback = (response) => {
				this.messageSuccess = response && response.message ? response.message : '';
				this.isJoining = false;
				this.isJoined = true;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.messageError = message;
				this.showErrorInformation = true;
				this.isJoining = false;
			};
			collaboratorsApi.joinedLink(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		invitationUrl() {
			const baseUrl = process.env.VUE_APP_URL;
			const urlResult = `${baseUrl}${this.$route && this.$route.path ? this.$route.path : ''}`;
			return urlResult;
		},
	},
	created() {
		this.joiningToRundown();
	},
};
</script>
